import { jsx as _jsx } from "react/jsx-runtime";
import { Button, MenuButton, QuestionCircleIcon } from "@fluentui/react-northstar";
import React from "react";
import { useInformationMenu } from "./InformationMenu.logic";
export const InformationMenu = (props) => {
    const logic = useInformationMenu(props);
    return (_jsx(MenuButton, { "data-testid": "informationMenu-btn", trigger: _jsx(Button, { "data-testid": "navbar-info-btn", icon: _jsx(QuestionCircleIcon, { outline: true }), iconOnly: true, disabled: props.isDisabled, styles: { pointerEvents: props.isDisabled ? "none" : "auto" } }), menu: logic.menu, on: "click" }));
};
